export default __webpack_public_path__ + "static/media/404error.3e7ce2d7.png";